import clsx from "clsx";
import { SwiperSlide } from "swiper/react";
import CarouselWrapper from "@components/Carousel/Wrapper";

export default function FeaturesSlider({ features }) {
    return (
        <CarouselWrapper style={{ "--swiper-theme-color": "#F5F5F5" }}>
            {features?.map(({ img, title, desc, leftSideText = false }) => {
                const BlueBox = () => (
                    <div
                        className={clsx(
                            blueBoxStyle +
                                (leftSideText
                                    ? ` lg:pl-14 ${leftStyle}`
                                    : ` lg:pr-14 ${rightStyle}`),
                        )}
                    >
                        <div className="mb-4 text-xl font-bold">{title}</div>
                        <div className="">{desc}</div>
                    </div>
                );
                return (
                    <SwiperSlide className="mb-10 flex flex-col lg:flex-row">
                        {leftSideText && <BlueBox />}
                        <img
                            src={img}
                            alt={desc}
                            className={clsx(
                                imgStyle +
                                    (leftSideText ? rightStyle : leftStyle),
                            )}
                            loading="lazy"
                        />
                        {!leftSideText && <BlueBox />}
                    </SwiperSlide>
                );
            })}
        </CarouselWrapper>
    );
}

const imgStyle = clsx("h-[300px] lg:w-3/5 object-cover object-left");
const blueBoxStyle = clsx(
    "relative flex lg:w-2/5 flex-col justify-center bg-blue p-8 pr-12",
);
const leftStyle = clsx(" lg:rounded-l-xl lg:rounded-tr-none rounded-t-xl");
const rightStyle = clsx(" lg:rounded-r-xl lg:rounded-bl-none rounded-b-xl");
